import { VStack, Text, Box, Button } from '@chakra-ui/react';
import { LoadingIcon } from '@/components/Icons/originals';

interface ProgressContentProps {
  whatWaitFor: string;
}

const ProgressContent = ({ whatWaitFor }: ProgressContentProps) => {
  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Box display="inline-block" animation="spin">
          <LoadingIcon boxSize={20} />
        </Box>
      </Box>
      <Text textAlign="center" pt={2}>{`Waiting for ${whatWaitFor}`}</Text>
      <VStack pt={{ base: 4, md: 8 }}>
        <Button
          loading
          loadingText="processing..."
          color="brand.staticWhite"
          fontSize="16px"
          fontWeight="bold"
          letterSpacing="1px"
          border="none"
          style={{
            background: 'linear-gradient(to right, #29A3CC, #AD13CC)',
            border: 'none',
          }}
          _hover={{
            opacity: 0.8,
          }}
        />
      </VStack>
    </>
  );
};
export default ProgressContent;
